export enum ELeadSheetPages {
  lot = 'lot',
  documents = 'documents',
  candidat = 'candidat',
  contact = 'contact',
  tache = 'tache'
}
